import { render, staticRenderFns } from "./ScrollButtons.vue?vue&type=template&id=67fc3fa6&"
import script from "./ScrollButtons.vue?vue&type=script&lang=js&"
export * from "./ScrollButtons.vue?vue&type=script&lang=js&"
import style0 from "./ScrollButtons.vue?vue&type=style&index=0&id=67fc3fa6&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports